// extracted by mini-css-extract-plugin
module.exports = {"menu-view__title":"s_9 my-2 p-2","menu-view__tile-row":"s_bb d-flex"};